import React from "react";
import { Link } from "react-router-dom";
import { 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaYoutube, 
  FaWhatsapp,
  FaChevronRight,
  FaHeart
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const routeMap = {
    "Vision & Mission": "/vision-mission",
    "University": "/university",
    "Principal Message": "/principal-message",
    "Chairman’s Message": "/chairman-message",
    
    "GNM": "/courses/gnm",
    "B.Sc.Nursing": "/courses/bsc-nursing",
    "Fee Structure": "/fee-structure",
    
    "Registration Form": "/admission/registration",
    "Prospectus": "/prospectus",
    "Affiliation": "/affiliation",
    
    "Home": "/",
    "Gallery": "/gallery",
    "Placement": "/placement",
    "Contact": "/contact",
    "Privacy": "/privacy",
    "Terms": "/terms",
    "Sitemap": "/sitemap"
  };

  const quickLinks = {
    about: ["Vision & Mission", "University", "Principal Message", "Chairman’s Message"],
    courses: [ "GNM", "B.Sc.Nursing", "Fee Structure"],
    admission: ["Registration Form", "Prospectus", "Affiliation"]
  };

  const socialLinks = [
    { Icon: FaFacebookF, url: "https://www.facebook.com/rdspharmacy", label: "Facebook" },
    { Icon: FaInstagram, url: "https://www.instagram.com/rdsgroup_of_colleges?igsh=MTNma2x6cTBwdGJwdA==", label: "Instagram" },
    { Icon: FaYoutube, url: "https://youtube.com/@rdscollegeofpharmacy8349?si=Onm4n5PHvFADYa4q", label: "YouTube" },
    { Icon: FaWhatsapp, url: "https://wa.me/917275370808", label: "WhatsApp" }
  ];

  return (
    <footer className="bg-blue-900 font-sans">
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <div className="md:col-span-4 space-y-4">
            <Link to="/" className="inline-block">
              <h3 className="text-xl font-bold text-white hover:text-blue-200 transition-colors">
                R.D.S. NURSING
              </h3>
              <p className="text-sm text-blue-200">PARAMEDICAL COLLEGE</p>
            </Link>
            
            <p className="text-sm text-blue-100 leading-relaxed">
              Empowering future healthcare professionals with quality nursing education since 1998.
            </p>
            <div className="flex items-center gap-3 pt-2">
              {socialLinks.map(({ Icon, url, label }, idx) => (
                <a 
                  key={idx}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center text-blue-100 hover:bg-blue-700 hover:text-white transition-colors text-base"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>
          {[
            { title: "About", items: quickLinks.about },
            { title: "Courses", items: quickLinks.courses },
            { title: "Admission", items: quickLinks.admission }
          ].map((section) => (
            <div key={section.title} className="md:col-span-2">
              <h4 className="text-sm font-semibold text-blue-300 uppercase tracking-wider mb-4">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.items.map((item) => (
                  <li key={item}>
                    <Link 
                      to={routeMap[item] || "#"}
                      className="group flex items-center gap-2 text-sm text-blue-100 hover:text-white transition-colors"
                    >
                      <FaChevronRight className="text-xs text-blue-400 opacity-0 group-hover:opacity-100 transition-all" />
                      <span>{item}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-8 pt-5 border-t border-blue-800">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex items-center gap-3">
              <FaMapMarkerAlt className="text-blue-400 text-base flex-shrink-0" />
              <a 
                href="https://maps.google.com/?q=Kushnow+Bhaupur+Jaunpur+222136"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-100 hover:text-white transition-colors"
              >
                Kushnow, Bhaupur, Jaunpur - 222136
              </a>
            </div>
            <div className="flex items-center gap-3">
              <FaPhoneAlt className="text-blue-400 text-base flex-shrink-0" />
              <div className="flex flex-wrap gap-3 text-sm">
                <a 
                  href="tel:+917275370808" 
                  className="text-blue-100 hover:text-white transition-colors"
                >
                  +917607094014
                </a>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <FaEnvelope className="text-blue-400 text-base flex-shrink-0" />
              <a 
                href="mailto:rdsnursing@gmail.com" 
                className="text-sm text-blue-100 hover:text-white transition-colors"
              >
                rdsnursing@gmail.com
              </a>
            </div>
          </div>
        </div>
        <div className="mt-5 pt-3 border-t border-blue-800 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs text-blue-300">
            © {currentYear} RDS Nursing & Paramedical College. All rights reserved.
          </p>
          <div className="flex items-center gap-3 text-xs">
            <Link to="/privacy" className="text-blue-300 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <span className="text-blue-700">•</span>
            <Link to="/terms" className="text-blue-300 hover:text-white transition-colors">
              Terms of Use
            </Link>
            <span className="text-blue-700">•</span>
            <Link to="/sitemap" className="text-blue-300 hover:text-white transition-colors">
              Sitemap
            </Link>
          </div>
          <div className="flex items-center gap-1 text-xs text-blue-400">
            <span>Made with</span>
            <FaHeart className="text-blue-300 text-sm" />
            <span>by RDS Team</span>
          </div>
        </div>
      </div>
      <div className="md:hidden fixed bottom-4 right-4 z-50">
        <a 
          href="https://wa.me/917275370808" 
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 rounded-full flex items-center justify-center text-white shadow-lg hover:bg-green-600 transition-all hover:scale-110"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp className="text-2xl" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;